import { useState, useEffect, useRef } from "react";
import {
  Bell,
  UserCircle2,
  Menu,
  ChevronDown,
} from "lucide-react";

import "./AdminHeader.css";

function AdminHeader({
  menuOpen,
  setMenuOpen,
}) {

  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const notificationRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {

    const handleClickOutside = (e) => {

      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }

      if (
        profileRef.current &&
        !profileRef.current.contains(e.target)
      ) {
        setShowProfileMenu(false);
      }

    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

    };

  }, []);

  return (

    <header className="admin-header">

      {/* Left */}

      <div className="admin-header-left">

        <button
          className="menu-btn"
          onClick={() =>
            setMenuOpen(!menuOpen)
          }
        >
          <Menu size={24} />
        </button>

        <div className="admin-logo">

          <img
            src="/images/logo.png"
            alt="HomeFoods"
          />

          <div>

            <h3>HomeFoods Admin</h3>

            <span>
              Administration Portal
            </span>

          </div>

        </div>

      </div>

      {/* Right */}

      <div className="admin-header-right">

        {/* Notifications */}

        <div
          className="notification-wrapper"
          ref={notificationRef}
        >

          <button
            className="notification-btn"
            onClick={() =>
              setShowNotifications(
                !showNotifications
              )
            }
          >

            <Bell size={22} />

            <span className="notification-count">
              0
            </span>

          </button>

          {showNotifications && (

            <div className="notification-dropdown">

              <h4>Notifications</h4>

              <div className="empty-notification">

                <Bell size={40} />

                <h5>No Notifications</h5>

                <p>
                  Everything is up to date.
                </p>

              </div>

            </div>

          )}

        </div>

        {/* Profile */}

        <div
          className="profile-wrapper"
          ref={profileRef}
        >

          <div
            className="header-profile"
            onClick={() =>
              setShowProfileMenu(
                !showProfileMenu
              )
            }
          >

            <UserCircle2 size={42} />

            <div className="profile-text">

              <h4>Administrator</h4>

              <p>Super Admin</p>

            </div>

            <ChevronDown size={18} />

          </div>

          {showProfileMenu && (

            <div className="profile-dropdown">

              <div className="dropdown-item">
                👤 My Profile
              </div>

              <div className="dropdown-item">
                ⚙️ Account Settings
              </div>

              <div className="dropdown-item">
                🔐 Change Password
              </div>

              <div className="dropdown-item logout">
                🚪 Logout
              </div>

            </div>

          )}

        </div>

      </div>

    </header>

  );

}

export default AdminHeader;